import { render } from "./LoginPageTipoA.vue?vue&type=template&id=d7b050b2&scoped=true"
import script from "./LoginPageTipoA.vue?vue&type=script&lang=js"
export * from "./LoginPageTipoA.vue?vue&type=script&lang=js"

import "./LoginPageTipoA.vue?vue&type=style&index=0&id=d7b050b2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d7b050b2"]])

export default __exports__